import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import OdinIcon from '../../odin-icon/odin-icon.component';
import FileActions from './file-actions.component';
import { getFileIcon, isImageFile } from './file-utils';

export interface FileListProps {
  files: File[];
  thumbnails: boolean;
  onRemove: (file: File) => void;
  isUploading?: boolean;
}

export default function FileList({ files, thumbnails = false, onRemove, isUploading = false }: FileListProps) {
  const containerStyles = clsx(
    'odin-flex odin-h-full odin-w-full',
    { 'odin-flex-col odin-p-1': !thumbnails },
    { 'odin-flex-row odin-flex-wrap odin-pl-2 odin-pt-2': thumbnails }
  );

  const itemStyles = clsx(
    'odin-group odin-flex odin-cursor-default',
    { 'odin-p-1 hover:odin-bg-gray-5': !thumbnails },
    { 'max-sm:odin-h-24 max-sm:odin-w-24 sm:odin-w-44 sm:odin-h-44 odin-max-w-full': thumbnails },
    {
      'odin-relative odin-mr-2 odin-mb-2 odin-cursor-default odin-items-center odin-justify-center odin-border odin-border-solid odin-border-primary-2 odin-text-primary-2':
        thumbnails,
    }
  );

  const itemIconStyles = clsx({ 'odin-mr-1': !thumbnails }, { 'odin-mx-1': thumbnails });

  const itemNameStyles = clsx('odin-truncate', { 'odin-flex-2': !thumbnails });

  const { t } = useTranslation();

  return (
    <div className={containerStyles}>
      <div className="odin-w-full odin-text-center odin-mb-2">
        {t('file-upload-more', 'Click to upload or drop more files here')}
      </div>
      {files.map((file) => (
        <div
          className={itemStyles}
          key={`${file.name}-${file.lastModified}`}
          onClick={(event) => event.preventDefault()}
        >
          {thumbnails && isImageFile(file.type) && (
            <img
              src={window.URL.createObjectURL(file)}
              className="odin-h-full odin-w-full odin-object-cover"
              title={file.name}
              alt={file.name}
            />
          )}
          {(!thumbnails || !isImageFile(file.type)) && (
            <>
              <OdinIcon icon={getFileIcon(file.type)} className={itemIconStyles} />
              <div className={itemNameStyles} title={file.name}>
                {file.name}
              </div>
            </>
          )}

          {!isUploading && <FileActions file={file} thumbnail={thumbnails} onRemove={onRemove} />}
        </div>
      ))}
    </div>
  );
}
